/**
 * EmptyState - Shared empty data placeholder
 */

import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({
  title = 'No data available',
  description = 'Data will appear once interactions are processed.',
  icon: Icon = Inbox,
}) => {
  return (
    <div className="text-center py-20 text-gray-500">
      <Icon size={32} className="mx-auto text-gray-300 mb-3" />
      <p className="text-lg">{title}</p>
      {description && <p className="text-sm mt-1">{description}</p>}
    </div>
  );
};

export default React.memo(EmptyState);
